import React from 'react';
import { Sprite } from '@agissc/ktag-map';

interface ImageLinkProps {
  image: string;
  linkUrl: string;
  toolTip: string;
  disabled?: boolean;
  clicked?: () => void;
}

const ImageLink = ({ image, linkUrl, toolTip, disabled, clicked }: ImageLinkProps) => {
  return (
    <div title={toolTip}>
      {disabled ? (
        <Sprite
          id={image}
          additionalClassNames="image-link-icon image-link-icon-disabled"
        />
      ) : (
        <a href={linkUrl} target="_blank" rel="noopener noreferrer" onClick={clicked}>
          <Sprite id={image} additionalClassNames="image-link-icon" />
        </a>
      )}
    </div>
  );
};

export default ImageLink;
